<template>
  <svg
    class="icon__glyph"
    width="42"
    height="50"
    viewBox="0 0 42 50"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <title>Bookmark Icon</title>
    <path
      v-if="isSaved === false"
      fill="#000000"
      fill-rule="nonzero"
      d="M6.0338 41.659L21 32.6079l14.9662 9.0513V5.9877H6.0338V41.659zM3 47V3h36v44L21 36.1139 3 47z"
    />
    <path
      v-if="isSaved === true"
      fill="#0157FF"
      fill-rule="evenodd"
      stroke="#0157FF"
      stroke-width="2"
      d="M5 4h32.8812v41.2547L21.4406 34.9308 5 45.2547z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isSaved: {
      type: Boolean,
      default: false
    }
  }
}
</script>
